import React from 'react';
import { NavLink } from 'react-router-dom';
import RestartQueue from '../AdminTools/components/components/RestartQueue';
import AuthService from '../../services/AuthService';

const NavigationBar = (props) => {
    return (
            <React.Fragment>
                <NavLink exact to="/admintools">
                    <button className="btn btn--xsmall btn--open" >Analytics</button>
                </NavLink>
                &nbsp;
                {AuthService.can('jobs') &&
                    <NavLink exact to="/admin?sec=job">
                        <button className="btn btn--xsmall btn--open" onClick={props.loadSection ? props.loadSection : null}  data-id="job">Jobs</button>
                    </NavLink>
                }
                &nbsp;
                {AuthService.can('API logs') &&
                    <NavLink exact to="/admin?sec=api">
                        <button className="btn btn--xsmall btn--open" onClick={props.loadSection ? props.loadSection : null} data-id="api">API Logs</button>
                    </NavLink>
                }
                &nbsp;
                {AuthService.can("IO logs") && 
                    <NavLink exact to="/io-logs">
                        <button className="btn btn--xsmall btn--open">IO Logs</button>
                    </NavLink>
                }
                &nbsp;
                {AuthService.can('Settings') &&
                    <NavLink exact to="/admin?sec=ovrd">
                        <button className="btn btn--xsmall btn--open" onClick={props.loadSection ? props.loadSection : null}  data-id="ovrd">Settings</button>
                    </NavLink>
                }
                &nbsp;
                {AuthService.can('stores') &&
                    <NavLink exact to="/new-store">
                        <button className="btn btn--xsmall btn--open" >Manage Stores</button>
                    </NavLink>
                }
                &nbsp;
                {AuthService.can('users') &&
                    <NavLink exact to="/new-users">
                        <button className="btn btn--xsmall btn--open" >Manage Users</button>
                    </NavLink>
                }
                &nbsp;
                {AuthService.can('area managers') &&
                    <NavLink exact to="/area-managers">
                        <button className="btn btn--xsmall btn--open" >Area Managers</button>
                    </NavLink>
                }
                &nbsp;
                {AuthService.can('Roles and permission') &&
                    <NavLink exact to="/roles_permissions" style={{ marginBottom: '10px', marginTop: '10px'  }}>
                        <button className="btn btn--xsmall btn--open" >Roles & Permissions</button>
                    </NavLink>
                }
                &nbsp;
                {AuthService.can('news') &&
                    <NavLink exact to="/news" style={{ marginBottom: '10px', marginTop: '10px'  }}>
                        <button className="btn btn--xsmall btn--open" style={{ marginBottom: '10px', marginTop: '10px'  }}>News</button>
                    </NavLink>
                }
            </React.Fragment>
    );
}

export default NavigationBar;